export default {
	name: 'base-modal',
	data () {
		return {
			dismissed: false
		}
	},
	props: {
		hasCloseButton: {
			type: Boolean,
			default: true
		},
		alignCenter: {
			type: Boolean,
			default: false
		},
        canCloseBackDrop: {
            type: Boolean,
            default: true
        },
        forceMobile: {
            type: Boolean,
            default: false
        },
        extraClasses: {
            type: String,
            default: ''
        },
		mobileBreakpoint: {
			type: Number,
			default: 575
		},
        layoutType: {
            type: String,
            required: true,
            default: 'default'
        },
        onClose: {
            type: Function,
            default: () => {}
        },
        windowHeight: {
            type: Number,
            default: 0
        }
	},
	mounted() {
        window.addEventListener("keydown", this.keydownEvents)
	},
    beforeDestroy() {
        window.removeEventListener("keydown", this.keydownEvents)
    },
    computed: {
        showDesktop() {
            return this.$root.$children[0].width > this.mobileBreakpoint
        }
    },
	methods: {
        closeModal(withOnClose) {
            this.$emit('close-modal')
            this.onClose()
            this.$destroy()
        },
        closeBackDrop() {
        	if(this.canCloseBackDrop) this.closeModal()
        },
        keydownEvents(e) {
            let code = e.keyCode
            switch(code){
                case 27: this.closeBackDrop()
                         break
            }
        }
	}
}